module.exports = "<div id=\"container-sfondo\">\r\n    <div id=\"sfondo\" class=\"swing swing-m\"> \r\n        <img class=\"image\" src=\"/assets/sfondo/pag_01_sfondo_largo.jpg\">\r\n        <img class=\"sfumatura\" src=\"/assets/sfondo/sfumatura_x_sfondo.png\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sfondo/sfondo.component.html
// module id = ./src/app/sfondo/sfondo.component.html
// module chunks = main